function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNumberIncreaseUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.99852 4.67185L4.99926 0.672593L1 4.67188",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 0.833184,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberIncreaseUp);
export default __webpack_public_path__ + "static/media/numberIncreaseUp.5d18c25c888cfddbb323028d50e9e35b.svg";
export { ForwardRef as ReactComponent };